export const gameSessionTimeSeconds = 20 * 60
export const optionSequenceSize = 12
export const startTipsSize = 1
